import { render } from "./MdsEntidad.vue?vue&type=template&id=4f6ac9d8&scoped=true"
import script from "./MdsEntidad.vue?vue&type=script&lang=js"
export * from "./MdsEntidad.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6ac9d8"]])

export default __exports__